module.exports = __webpack_public_path__ + "img/cq1.180a6345.jpg";